import React, { useState, useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import LogoHorus from "../../assets/bg-horus.png";

function Apresentacao() {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleWhatsappClick = (local) => {
    const localMap = {
      'sarandi': '5544991295607',
      'marialva': '5544991225656'
    }
    window.location.href = `https://api.whatsapp.com/send?phone=${localMap[local]}`;
  };

  const [contatoModalOpen, setContatoModalOpen] = useState(false);

  const openContatoModal = () => {
    setContatoModalOpen(true);
  };

  const closeModal = () => {
    setContatoModalOpen(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.id === "modal-container") {
      closeModal();
    }
  };

  return (
    <div className="bg-gradient-to-br from-slate-100 to-blue-300 text-blue-800 min-h-screen flex items-center">
      <div className="flex flex-col md:flex-row w-full p-10 items-center md:max-h-[300px] gap-20 sm:gap-1">
        <div className="text-left w-full pl-10 self-start">
          <Typography variant="h4" className="font-bold">
            CUIDANDO DA SUA VISÃO COM EXCELÊNCIA
          </Typography>
          <Typography variant="body1" className="mt-2">
            Consultas e exames oftalmológicos com tecnologia de ponta.
          </Typography>
          <button
            className="mt-6 max-w-[200px] rounded-full px-6 self-center py-3 bg-blue-500 text-white font-bold hover:bg-blue-600"
            onClick={openContatoModal}
          >
            Agendar Consulta
          </button>
        </div>
        <div className="ml-auto flex justify-center align-middle items-center w-full">
          <img src={LogoHorus} alt="Clínica Horus" className="-mt-[100px]" />
        </div>
      </div>
      {contatoModalOpen && (
        <div 
          id="modal-container" 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={handleClickOutside}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 md:w-1/2 lg:w-1/3 relative">
            <button 
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={closeModal}
            >
              &times;
            </button>
            <h3 className="text-xl font-semibold text-blue-900 mb-2">Estamos situados em dois endereços!</h3>
            
            <div className="flex flex-row gap-4 justify-center align-middle p-4 items-center"> 
              <button
                className="mt-6 max-w-[200px] rounded-full px-6 self-center py-3 bg-blue-500 text-white font-bold hover:bg-blue-600"
                onClick={() => handleWhatsappClick('sarandi')}
              >
                Falar c/ Sarandi
              </button>
              <button
                className="mt-6 max-w-[200px] rounded-full px-6 self-center py-3 bg-blue-500 text-white font-bold hover:bg-blue-600"
                onClick={() => handleWhatsappClick('marialva')}
              >
                Falar c/ Marialva
              </button>
            </div>


          </div>
        </div>
      )}
    </div>
  );
}

export default Apresentacao;